import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'neq-validation-component',
  templateUrl: './validation.component.html',
})
export class NeqValidationComponent implements OnInit {

  constructor(
    private readonly dialogRef: MatDialogRef<NeqValidationComponent>
  ) {}

  ngOnInit() {
    // Required
  }

  continue() {
    this.dialogRef.close(true);
  }

  goBack() {
    this.dialogRef.close(false);
  }
}
